// The E2E script can only run on this tenant
const E2E_SCRIPT_TENANT = "create-test-tenant-and-users-do-not-delete"

module.exports = E2E_SCRIPT_TENANT